"use client"

import { motion } from "motion/react"
import { EnvelopeIcon } from "@heroicons/react/24/outline"
import { DarkText } from "@ui/text"

interface Props {
    label: string
}

export function CheckInbox({ label }: Props) {
    return (
        <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 10 }}
            transition={{ duration: 0.3 }}
        >
            <div className="flex flex-col items-center space-y-4 p-4">
                <motion.div
                    initial={{ scale: 0.8 }}
                    animate={{ scale: 1 }}
                    transition={{ duration: 0.2 }}
                    className="bg-primary-50 rounded-full p-2"
                >
                    <EnvelopeIcon className="text-primary-800 size-16" />
                </motion.div>
                <DarkText className="text-md text-center">{label}</DarkText>
            </div>
        </motion.div>
    )
}
